import { BaseService } from '../config/request';
import { CheckInSummaryApiResponseModel, CheckInSummaryParams } from '../models/checkins-model';

export async function fetchCheckInSummaryData(params: CheckInSummaryParams): Promise<CheckInSummaryApiResponseModel> {
  return (await BaseService.getAsync(`checkins`, params)) as CheckInSummaryApiResponseModel;
}
